export default [
  { "value": "ar", "label": "العربية" },
  { "value": "bg", "label": "Български" },
  { "value": "ca", "label": "Català" },
  { "value": "cs", "label": "Čeština" },
  { "value": "de", "label": "Deutsch" },
  { "value": "el", "label": "Ελληνικά" },
  { "value": "en", "label": "English" },
  { "value": "es", "label": "Español" },
  { "value": "fi", "label": "Suomi" },
  { "value": "fr", "label": "Français" },
  { "value": "hi", "label": "मानक हिन्दी" },
  { "value": "hu", "label": "Magyar" },
  { "value": "id", "label": "Indonesian" },
  { "value": "it", "label": "Italiano" },
  { "value": "ja", "label": "日本語" },
  { "value": "ko", "label": "한국어" },
  { "value": "ms", "label": "بهاس ملايو" },
  { "value": "nl", "label": "Nederlands" },
  { "value": "no", "label": "Norsk" },
  { "value": "pl", "label": "Polski" },
  { "value": "pt", "label": "Português" },
  { "value": "ro", "label": "Română" },
  { "value": "ru", "label": "Русский" },
  { "value": "sk", "label": "Slovenčina" },
  { "value": "sv", "label": "Svenska" },
  { "value": "th", "label": "ภาษาไทย" },
  { "value": "tl", "label": "Tagalog" },
  { "value": "tr", "label": "Türkçe" },
  { "value": "uk", "label": "Українська" },
  { "value": "vi", "label": "Tiếng Việt" },
  { "value": "zh", "label": "中文" },
  { "value": "zh-hk", "label": "粵語" },
  { "value": "asl", "label": "American Sign Language" },
]